import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import dayjs from 'dayjs'
// Pre-register locales so they are available when languageChanged fires during init()
import 'dayjs/locale/ru'
import 'dayjs/locale/en'
import en from './en'
import ru from './ru'

// Sync dayjs locale BEFORE React re-renders so date formatting is correct
// on the very first render after a language change.
i18n.on('languageChanged', (lng) => {
  dayjs.locale(lng.startsWith('ru') ? 'ru' : 'en')
})

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en, ru },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'app-language',
      caches: ['localStorage'],
    },
  })

export default i18n
